<template>
  <div class="category-page">
    <!-- 搜索与时间筛选区 -->
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="分类号搜索">
          <el-input 
            v-model="searchForm.keyword" 
            placeholder="请输入中图分类号（如F27）" 
            clearable
            style="width: 280px;"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="时间区间">
          <el-date-picker
            style="width:130px"
            value-format="yyyy"
            type="year"
            placeholder="开始年份"
            v-model="searchForm.startYear"
          >
          </el-date-picker>
          <span style="margin:0 8px">-</span>
          <el-date-picker
            style="width:130px"
            value-format="yyyy"
            type="year"
            placeholder="结束年份"
            v-model="searchForm.endYear"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 数据统计概览 -->
    <el-card shadow="hover" class="stats-card">
      <div class="stats-container">
        <div class="stat-item">
          <span class="stat-label">统计区间</span>
          <span class="stat-value">{{ dateRangeText }}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">总图书数量</span>
          <span class="stat-value">{{ totalCount }} 种</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">分类数量</span>
          <span class="stat-value">{{ filteredData.length }} 个</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">分类总数量</span>
          <span class="stat-value">{{ totalCategoryBooks }} 种</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">类别总占比</span>
          <span class="stat-value">{{ totalRatio.toFixed(2) }}%</span>
        </div>
        <!-- <div class="stat-item">
          <span class="stat-label">平均每类</span>
          <span class="stat-value">{{ avgBooks.toFixed(1) }} 种</span>
        </div> -->
      </div>
    </el-card>
    
    <!-- 左右对称双栏表格 -->
    <el-card shadow="hover" class="table-card">
      <div class="double-table">
        <!-- 左栏 -->
        <div class="table-half">
          <el-table 
            :data="leftData" 
            border 
            stripe 
            size="medium"
            :header-cell-style="{background: '#f5f7fa', color: '#333'}"
            v-loading="loading"
          >
            <el-table-column label="序号" type="index" width="70" align="center" />
            <el-table-column label="中图分类号" prop="中图分类号" min-width="180" />
            <el-table-column label="图书数量（种）" align="right" width="160">
              <template slot-scope="scope">
                {{ getBookCount(scope.row) }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 右栏 -->
        <div class="table-half">
          <el-table 
            :data="rightData" 
            border 
            stripe 
            size="medium"
            :header-cell-style="{background: '#f5f7fa', color: '#333'}"
            v-loading="loading"
          >
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{ leftData.length + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="中图分类号" prop="中图分类号" min-width="180" />
            <el-table-column label="图书数量（种）" align="right" width="160">
              <template slot-scope="scope">
                {{ getBookCount(scope.row) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      
      <div class="pagination-container" style="margin-top:20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredData.length"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import categoryData from '../../dataJson/category_ratio_data.json'

export default {
  name: 'CategoryRatioPage',
  data() {
    return {
      searchForm: {
        keyword: '',
        startYear: '',
        endYear: ''
      },
      currentPage: 1,
      pageSize: 20,
      loading: false,
      originalData: categoryData.data,
      filteredData: [],
      leftData: [],
      rightData: [],
      totalInfo: categoryData.total_info,
      currentDataType: '2025',
      avgBooks: 0
    }
  },
  computed: {
    dateRangeText() {
      const { startYear, endYear } = this.searchForm
      if (startYear && endYear) {
        return `${startYear} ~ ${endYear}`
      }
      return '全部时间'
    },
    totalCount() {
      return this.currentDataType === '2023' 
        ? this.totalInfo['2023年后总数'] || 0 
        : this.totalInfo['2025年后总数'] || 0
    },
    totalCategoryBooks() {
      return this.filteredData.reduce((sum, item) => {
        const count = this.currentDataType === '2023'
          ? (item['2023年后图书数量'] || 0)
          : (item['2025年后图书数量'] || 0)
        return sum + Number(count)
      }, 0)
    },
    totalRatio() {
      if (this.totalCount === 0) return 0
      return (this.totalCategoryBooks / this.totalCount) * 100
    }
  },
  mounted() {
    this.filteredData = [...this.originalData]
    this.calculateStats()
    this.splitTableData()
  },
  methods: {
    getBookCount(row) {
      if (this.currentDataType === '2023') {
        return row['2023年后图书数量'] || 0
      }
      return row['2025年后图书数量'] || 0
    },

    calculateStats() {
      const counts = this.filteredData.map(item => this.getBookCount(item))
      this.avgBooks = counts.length ? counts.reduce((a, b) => a + b, 0) / counts.length : 0
    },

    splitTableData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      const pageData = this.filteredData.slice(start, end)
      
      const half = Math.ceil(pageData.length / 2)
      this.leftData = pageData.slice(0, half)
      this.rightData = pageData.slice(half)
    },
    
    handleSearch() {
      this.loading = true
      const keyword = this.searchForm.keyword.trim().toUpperCase()
      const { startYear } = this.searchForm

      if (startYear) {
        this.currentDataType = startYear <= '2023' ? '2023' : '2025'
      } else {
        this.currentDataType = '2025'
      }

      setTimeout(() => {
        this.filteredData = this.originalData.filter(item => {
          return item['中图分类号'].toUpperCase().includes(keyword)
        })
        
        this.calculateStats()
        this.currentPage = 1
        this.splitTableData()
        this.loading = false
      }, 200)
    },
    
    resetSearch() {
      this.searchForm = { keyword: '', startYear: '', endYear: '' }
      this.currentDataType = '2025'
      this.filteredData = [...this.originalData]
      this.calculateStats()
      this.currentPage = 1
      this.splitTableData()
    },
    
    handleSizeChange(val) {
      this.pageSize = val
      this.splitTableData()
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
      this.splitTableData()
    }
  }
}
</script>

<style scoped>
.category-page {
  padding: 20px;
  background-color: #f9fafc;
  min-height: calc(100vh - 60px);
}
.search-card, .stats-card, .table-card {
  margin-bottom: 20px;
}
.search-form {
  display: flex;
  align-items: center;
  gap: 15px;
}
.stats-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.stat-item {
  flex: 1;
  min-width: 150px;
  text-align: center;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 6px;
}
.stat-label {
  font-size: 14px;
  color: #666;
}
.stat-value {
  font-size: 16px;
  font-weight: 500;
}
.pagination-container {
  text-align: right;
}

.double-table {
  display: flex;
  gap: 10px;
  width: 100%;
}
.table-half {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/categoryproportion.vue